import React from 'react';
import styled from 'styled-components';
import { UrbanCompassLogoBlack } from '../../../icons';
// import CityOfOretonLogo from '../../../settings/moretonBayLogo';

const ReportContainer = styled.div`
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  max-width: 100%;

  h3 {
    color: #2c3e50;
    border-bottom: 2px solid #eee;
    padding-bottom: 8px;
    margin-top: 30px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }

  th,
  td {
    border: 1px solid #ddd;
    padding: 12px;
  }

  th {
    background-color: #f2f2f2;
    text-align: left;
  }

  p {
    margin-bottom: 15px;
    font-size: 15px;
  }

  ul {
    margin-left: 20px;
    margin-bottom: 20px;
  }

  li {
    margin-bottom: 8px;
  }
`;

const SectionContainer = styled.div`
  margin-bottom: 30px;
  break-inside: avoid;
  scroll-margin-top: 110px;
`;

const TOCContainer = styled.div`
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 30px;

  h4 {
    margin-top: 0;
    margin-bottom: 10px;
  }

  ul {
    margin-bottom: 0;
  }
`;

const ReportDisplay = ({ reportData }) => {
  if (!reportData || !Array.isArray(reportData)) {
    return <p>No report data available</p>;
  }

  // Sort sections by ID to ensure proper order
  const sortedSections = [...reportData].sort((a, b) => {
    // Extract section numbers from heading (if possible)
    const getHeadingNumber = (section) => {
      if (!section.sectionData) return 999;
      const match = section.sectionData.match(/<h3[^>]*>(\d+)\./i);
      return match ? parseInt(match[1], 10) : 999;
    };

    return getHeadingNumber(a) - getHeadingNumber(b);
  });

  // Generate table of contents
  const generateTOC = () => {
    const tocItems = sortedSections
      .map((section) => {
        if (!section.sectionData) return null;

        // Try to extract the heading text
        const headingMatch = section.sectionData.match(/<h3[^>]*>(.*?)<\/h3>/i);
        if (!headingMatch) return null;

        const headingText = headingMatch[1];
        return {
          id: section.id,
          title: headingText.replace(/&[^;]+;/g, ' '), // Remove HTML entities
        };
      })
      .filter(Boolean);

    return (
      <TOCContainer id="table-of-contents">
        <h4>Table of Contents</h4>
        <ul>
          {tocItems.map((item) => (
            <li key={item.id}>
              <a href={`#section-${item.id}`}>{item.title}</a>
            </li>
          ))}
        </ul>
      </TOCContainer>
    );
  };

  return (
    <ReportContainer>
      <h2 style={{ paddingBottom: '6px' }}>
        <UrbanCompassLogoBlack />
        {/* <CityOfOretonLogo color={'#000'} /> */}
      </h2>
      {generateTOC()}

      {sortedSections.map((section) => (
        <SectionContainer key={section.id} id={`section-${section.id}`}>
          <div dangerouslySetInnerHTML={{ __html: section.sectionData }} />
        </SectionContainer>
      ))}
    </ReportContainer>
  );
};

export default ReportDisplay;
